import Request from '../../request';

const VesselRequisitionItemPricingService = {
  create: async (data: FormData): Promise<void> => {
    try {
      await Request.post(`/api/vessels/requisitions/items/pricings`, data, 'multipart/form-data');
    } catch (e) {
      throw e;
    }
  },
  approve: async (data: FormData): Promise<{}> => {
    try {
      const result = await Request.post(`/api/vessels/requisitions/items/pricings/approve`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  reject: async (data: FormData): Promise<{}> => {
    try {
      const result = await Request.post(`/api/vessels/requisitions/items/pricings/reject`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  }
};

export default VesselRequisitionItemPricingService;
